import { Position, State } from 'src/types'
import { lace } from 'src/features/dxm/drawer/rightThrow/glove/back/lace'
import { lining } from 'src/features/dxm/drawer/rightThrow/glove/back/lining'
import { littleHook } from 'src/features/dxm/drawer/rightThrow/glove/back/fingerHooks/littleHook'
import { thumbHook } from 'src/features/dxm/drawer/rightThrow/glove/back/fingerHooks/thumbHook'
import { webOfGloveBackDrawer } from 'src/features/dxm/drawer/rightThrow/glove/back/web/useCanvasWebsBack'
import { loopOfRingFingerDrawer } from 'src/features/dxm/drawer/rightThrow/glove/back/loopOfRingFinger'
import { backStyleOfGloveBackDrawerLeftThrow } from 'src/features/dxm/drawer/leftThrow/glove/back/backStyles'
import { laceOfWristBeltCrossDrawer } from 'src/features/dxm/drawer/rightThrow/glove/back/lace/laceOfWristBeltFix'
import { canvasResetter } from 'src/util/canvas'
import { fingerGuardDrawer } from 'src/features/dxm/drawer/rightThrow/glove/back/fingerCoverOrPad/fingerGuardDrawer'
import { dxmLabel } from 'src/features/dxm/drawer/rightThrow/glove/back/label'
import { liningEmbroideryDrawerLeftThrow, nonThumbEmbroideryDrawerLeftThrow, startInversion, undoInversion } from 'src/util/canvas'

export const dxmCanvasGloveBackLeftThrow = (ctx: CanvasRenderingContext2D, state: State, position: Position, canvasWidth: number): void => {
  // リセット
  canvasResetter(ctx)
  startInversion(ctx, canvasWidth)
  // 裏革
  lining(ctx, state.linings?.color)
  // 薬指リング // カラー指定どうするか
  loopOfRingFingerDrawer(ctx, state?.loopOfRingFingerColor?.color, state.stitch.color, state.loopOfRingFinger?.value)

  undoInversion(ctx, canvasWidth)
  // 平裏の刺繍描画1段目
  liningEmbroideryDrawerLeftThrow(ctx, state.embroideries, 'first')
  // 平裏の刺繍描画2段目
  liningEmbroideryDrawerLeftThrow(ctx, state.embroideries, 'second')

  // バックスタイルの描画(ハミダシ,親指刺繍含)
  backStyleOfGloveBackDrawerLeftThrow(ctx, state, position, canvasWidth)
  startInversion(ctx, canvasWidth)
  // 指カバー・パッド
  fingerGuardDrawer(ctx, state)
  // 小指への刺繍

  undoInversion(ctx, canvasWidth)
  nonThumbEmbroideryDrawerLeftThrow(ctx, 'childFinger', state.embroideries)
  startInversion(ctx, canvasWidth)
  // ウェブの描画
  webOfGloveBackDrawer(ctx, state)
  // 革紐
  lace(ctx, state.lace?.color)

  laceOfWristBeltCrossDrawer(ctx, state.lace?.color)
  // 小指掛け紐
  littleHook(ctx, state.littleHook?.color, 25, 240, -10, 0.7)
  // 親指掛け紐
  thumbHook(ctx, state.thumbHook?.color, 110, -310, 15) // 先端
  thumbHook(ctx, state.thumbHook?.color, -14, 30, 0) //手元

  undoInversion(ctx, canvasWidth)

  // ラベル描画
  switch (state.backStyle?.value) {
    case 'dWave':
      dxmLabel(ctx, state, 260, -480, 50, 0.9)
      break
    default:
      dxmLabel(ctx, state, 130, -90, 10, 1)
      break
  }
}
